import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  media: {
    borderRadius: '20px',
    objectFit: 'cover',
    // width: "100%",
    // maxHeight: "600px",
    maxWidth: '800px',
    maxHeight: '600px ',
    [theme.breakpoints.down('md')]: { maxWidth: '700px', maxHeight: '800px ' },
    [theme.breakpoints.down('sm')]: { maxWidth: '500px', maxHeight: '700px ' },
    [theme.breakpoints.down('xs')]: { maxWidth: '300px', maxHeight: '500px ' },
    ['@media (max-width:1100px)']: { maxWidth: '550px', maxHeight: '750px' },
    ['@media (max-width:650px)']: { maxWidth: '400px', maxHeight: '600px' },
    ['@media (max-width:480px)']: { maxWidth: '350px', maxHeight: '550px' },
  },
  card: {
    display: 'flex',
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      flexDirection: 'column',
    },
  },
  section: {
    borderRadius: '20px',
    margin: '10px',
    flex: 1,
  },
  imageSection: {
    marginLeft: '20px',
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
  },
  recommendedPosts: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  loadingPaper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    borderRadius: '15px',
    height: '39vh',
  },
  similarPost: {
    margin: '20px',
    cursor: 'pointer',

    padding: theme.spacing(2),

    borderRadius: '15px',
    minWidth: '15em',
    minHeight: '15em',
    maxWidth: '25em',
    maxHeight: '25em',

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    backgroundColor: '#f1f1f1',
  },
  picRecommended: {
    borderRadius: '10px',
    maxWidth: '400px',
    maxHeight: '270px ',
    objectFit: 'cover',
  },
  commentsOuterContainer: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  commentsInnerContainer: {
    height: '200px',
    overflowY: 'auto',
    marginRight: '30px',
  },
  commentButton:{
    backgroundColor: '#2D93D3',
    marginTop:'10px',
    color:'white',

    "&:hover": {
      backgroundColor: "#1e88ca",
    },
  },
}))
